import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-210dfe94"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusKeyButton',
  props: {
    onClick: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "statusKeyButton",
    "aria-label": _ctx.$t('Status key button aria label'),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_unref(Icon), { "icon-name": "statusNormal" }),
    _createVNode(_unref(Icon), { "icon-name": "statusAtRisk" }),
    _createVNode(_unref(Icon), { "icon-name": "statusDelayed" }),
    _createVNode(_unref(Icon), { "icon-name": "statusCancelled" })
  ], 8, _hoisted_1))
}
}

})